import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewComments',
  emits: ['onChange'],
  setup(__props, { emit }) {



const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  emit('onChange', target.value)
}

return { __sfc: true,emit, onChange }
}

})